<ng-container *ngIf="loading; else loaded">
    <div class="loading-wrapper">
        <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1676539537510delivery%20robot.png" alt="Loading">
        <h4 class="text-primary">Hold a while...</h4>
    </div>
</ng-container>
<ng-template #loaded>
    <div class="content-height d-lg-block d-none">
        <div class="row h-100">
            <ng-container *ngIf="vendors?.length > 0; else noCriteria">
                <div class="col-4 image-section position-relative">
                    <div class="position-absolute top-50 start-50 translate-middle text-center">
                        <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718187347241Working%203d%201%20%284%29.png" alt="">
                        <h5>Select the banks that you find the best</h5>
                        <p>& send the application in just one click.</p>
                    </div>

                </div>

                <div class="col-8 bg-white">
                    <div class="d-flex align-items-center justify-content-between mt-2 p-2 bg-white mx-2">
                        <div>
                            <h4 (click)="back()" class="text-primary-dark back"><i class="bi bi-arrow-left me-2 text-primary"></i>Your Loan Offers
                            </h4>
                        </div>

                        <div class="d-flex justify-content-between align-items-center loan-details-div px-1">
                            <img class="img img-fluid me-2" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718188495673Icon%20%282%29.png" alt="">
                            <p class="mt-3 me-2 text-gray">{{loanService?.loanDetails?.loanType}}</p>
                            <p class="mt-3"><span class="fw-bold">{{loanService?.loanDetails?.loanAmountCurrency}}
                                    {{prepareViewLoanAmount(loanService?.loanDetails?.loanAmount)}}</span>
                            </p>
                        </div>

                        <button [apnstTooltip]="openSortByModal" class="btn sortByBtn rounded-1-custom mt-2 px-1 py-1"><img class="img img-fluid me-2"
                                src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1708595764424sort.png"
                                alt="filterIcon">Sort By</button>

                        <div ngbDropdown class="">
                            <i id="dropdownBasic1" ngbDropdownToggle class="fs-3 bi bi-three-dots-vertical dots text-primary-dark"></i>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <button (click)="logout()" ngbDropdownItem><i class="bi bi-box-arrow-right me-2"></i>
                                    Logout</button>
                            </div>
                        </div>
                    </div>

                    <div class="bg-light">
                        <ng-container *ngIf="vendors?.length > 0;">
                            <div class="vendorDetails row row-cols-2 overflow-hide px-2 bg-light">
                                <ng-container *ngFor="let vendor of vendors;index as i">
                                    <div class="mb-5 mt-2" (click)="addRemoveVendor(vendor,vendor?.id)">
                                        <div class="custom-card-border bg-white px-3 mt-3 position-relative" [ngClass]="{' border border-primary':isSelected[vendor?.id]}">
                                            <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715766968416Listed.png" *ngIf="isSelected[vendor?.id]" class="img img-fluid position-absolute selected" alt="selected">
                                            <p class="uniListedText w-50 text-center py-1" *ngIf="loanService?.studentDetails?.universityVendors?.includes(vendor?.vendorNameCaseChanged)">
                                                <span class="text-white"><i class="bi bi-check2 me-2"></i>Better
                                                    Approval Chance</span>
                                            </p>

                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="">
                                                    <ng-container *ngIf="vendor?.company?.logo && !vendor?.company?.logo?.includes('public'); else publicLogo">
                                                        <div class="">
                                                            <fa-async-image class="d-block" [src]="vendor?.company?.logo" styleClass="custom-logo-size"></fa-async-image>
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #publicLogo>
                                                        <div class="">
                                                            <img class="custom-logo-size" [src]="vendor?.company?.logo" [alt]="vendor?.company?.name">
                                                        </div>
                                                    </ng-template>
                                                </div>

                                                <div class="mt-3">
                                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                                        <img class="img img-fluid me-1" width="14" src="../../../../assets/logo/rateofinterest.svg" alt="interestLogo">
                                                        <p class="text-gray mb-0">Rate of Interest</p>
                                                    </div>
                                                    <div class="mt-n2">
                                                        <p class="text-primary-dark fw-bold text-end" *ngIf="loanService?.loanDetails?.loanType==='Secured Loan(with Property)'">
                                                            {{vendor?.company?.vendorDetails?.collateral?.rateOfInterest}}
                                                        </p>
                                                        <p class="text-primary-dark fw-bold text-end" *ngIf="loanService?.loanDetails?.loanType==='Unsecured Loan(without Property)'||loanService?.loanDetails?.loanType==='International Loan(Non Collateral-Cosigner)'">
                                                            {{vendor?.company?.vendorDetails?.nonCollateral?.rateOfInterest}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr class="text-gray mt-n2">

                                            <div class="d-flex justify-content-between align-items-center mt-n3">
                                                <div class="d-flex justify-content-start align-items-center">
                                                    <img class="img img-fluid me-2" width="22" src="../../../../assets/logo/processing-fee.svg" alt="processFeeLogo">
                                                    <p class="text-gray mt-3">Processing Fee</p>
                                                </div>
                                                <p class="text-primary-dark fw-bold mt-3">
                                                    {{vendor?.company?.vendorDetails?.processingFee}}</p>
                                            </div>

                                            <div class="d-flex justify-content-between align-items-center mt-n4">
                                                <div class="d-flex justify-content-start align-items-center mb-0">
                                                    <img class="img img-fluid me-2" width="22" src="../../../../assets/logo/approval.svg" alt="processFeeLogo">
                                                    <p class="text-gray mt-3">Approval Time</p>
                                                </div>
                                                <p class="text-primary-dark fw-bold mt-3">
                                                    {{vendor?.company?.vendorDetails?.tat}}</p>
                                            </div>

                                            <div class="d-flex justify-content-between align-items-center mt-n4">
                                                <div class="d-flex justify-content-start align-items-center mb-0">
                                                    <img class="img img-fluid me-2" width="22" src="../../../../assets/logo/tenure.svg" alt="processFeeLogo">
                                                    <p class="text-gray mt-3">Loan Tenure</p>
                                                </div>
                                                <p class="text-primary-dark fw-bold mt-3">
                                                    {{vendor?.company?.vendorDetails?.tenure}}</p>
                                            </div>

                                            <div class="d-flex justify-content-between align-items-center mt-n4">
                                                <div class="d-flex justify-content-start align-items-center mb-0">
                                                    <img class="img img-fluid me-2" width="22" src="../../../../assets/logo/repayment.svg" alt="processFeeLogo">
                                                    <p class="text-gray mt-3">Repayment Mode</p>
                                                </div>
                                                <p class="text-primary-dark fw-bold mt-3">
                                                    {{loanService?.studentDetails?.targetDegree==='Bachelors' ? vendor?.company?.vendorDetails?.repaymentOptions?.bachelors:vendor?.company?.vendorDetails?.repaymentOptions?.masters}}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-5 terms bg-white pb-0">
                        <div class="d-flex justify-content-center align-items-start">
                            <i class="bi bi-info-circle me-1 fs-4 text-gray"></i>
                            <p class="text-gray">These offers are listed only based on eligibility criteria <br> met with academic and financial factors. The final offer <br> may vary based on the document verification. Read More
                            </p>
                        </div>

                        <button class="btn btn-primary gradient py-2 px-10 me-2" [ngClass]="{'btn-primary':selectedVendors?.length>0,'btn-gray text-white disabled':selectedVendors?.length===0}" (click)="sendApplication()">Send Application</button>
                    </div>

                </div>
            </ng-container>

            <ng-template #noCriteria>
                <div class="col-12 col-lg-8 image-section" [class.image-section-partner]="isPartnerLink">
                    <div class="container h-100">
                        <div class="d-flex flex-column justify-content-between align-items-center py-4 h-100">
                            <div class="d-flex justify-content-between align-items-start w-100">
                                <div>
                                    <ng-container *ngIf="isPartnerLink; else FAlogo">
                                        <img *ngIf="partnerLogo" class="img img-fluid" width="120" [src]="partnerLogo" alt="Education Loan">
                                    </ng-container>
                                    <ng-template #FAlogo>
                                        <img class="img img-fluid" width="120" src='https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1674449525190Group%20%281%29.png' alt="Education Loan">
                                    </ng-template>
                                </div>
                                <div>
                                    <h1 class="text-white mb-0 text-end">Join the</h1>
                                    <p class="outline-text mt-n2">Wait list</p>
                                </div>
                            </div>
                            <div class="px-7 mt-n7 mt-lg-n10 mb-3">
                                <img class="img img-fluid" width="200" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1674539906771robot%20sad.png" alt="Suggested Banks">
                            </div>

                            <div class="">
                                <p class="text-primary-dark text-center fw-bold mb-2">
                                    FACTORS THAT AFFECT YOUR CHANCES
                                </p>
                                <div class="row row-cols-2 row-cols-lg-3 flex-nowrap">
                                    <div class="col" [class.text-primary-dark]="isPartnerLink" [class.text-white]="!isPartnerLink">
                                        <div class="d-flex align-items-start">
                                            <h2><i class="bi bi-grid-1x2-fill me-2"></i></h2>
                                            <div>
                                                <h6 class="mb-0">Your Academic Experience</h6>
                                                <p class="fw-light mb-0 smaller">
                                                    Ranking of your University, Low GRE scores, Course and specialisation changes might affect your chances
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col" [class.text-primary-dark]="isPartnerLink" [class.text-white]="!isPartnerLink">
                                        <div class="d-flex align-items-start">
                                            <h2><i class="bi bi-grid-1x2-fill me-2"></i></h2>
                                            <div>
                                                <h6 class="mb-0">Your Loan Request</h6>
                                                <p class="fw-light mb-0 smaller">
                                                    Valid co-applicant, Lower value of collateral, Less income than loan amount requested might affect your chances
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col" [class.text-primary-dark]="isPartnerLink" [class.text-white]="!isPartnerLink">
                                        <div class="d-flex align-items-start">
                                            <h2><i class="bi bi-grid-1x2-fill me-2"></i></h2>
                                            <div>
                                                <h6 class="mb-0">Credit History</h6>
                                                <p class="fw-light mb-0 smaller">
                                                    Default accounts and more late repayments of yours as well as your co-applicants may affect your chances
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="isPartnerLink && loanService?.loanDetails?.partnerDetails?.company?.showWhiteLabelled" class="d-flex justify-content-center align-items-center flex-column">
                                    <div class="d-flex justify-content-center align-items-center mb-2">
                                        <p class="mb-0 me-2">Powered by</p>
                                        <img width="120px" class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1674329951680Group.png" alt="Education Loan">
                                    </div>

                                    <p class="text-primary-dark text-center mb-3 fw-bold"><span class="me-2">10000+ Loan
                                            Applications
                                            Processed</span> <span class="me-2">|</span> <span class="me-2">500+ Crore
                                            Amount
                                            Processed</span> <span class="me-2">|</span> <span>17+ Banking
                                            Partners</span></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div class="container h-100 position-relative px-4">
                        <div ngbDropdown class="d-flex align-items-end justify-content-end mt-2">
                            <i id="dropdownBasic1" ngbDropdownToggle class="fs-3 bi bi-three-dots-vertical dots text-primary-dark"></i>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <button (click)="logout()" ngbDropdownItem><i class="bi bi-box-arrow-right me-2"></i>
                                    Logout</button>
                            </div>
                        </div>
                        <div class="position-absolute right-side">
                            <div>
                                <h1 class="text-secondary text-center mb-5">
                                    <span class="text-primary">Join </span> the Waitlist
                                </h1>
                            </div>
                            <div class="mb-4 mb-lg-7">
                                <p class="text-muted text-center smaller">Our AI tool didn't provide you offers, Enquire now to apply manually</p>
                            </div>
                            <div>
                                <div class="mb-3 mb-lg-5">
                                    <button (click)="startOver()" class="btn btn-primary gradient rounded-1 py-2 px-6 w-100">Start
                                        Over</button>
                                </div>
                                <div>
                                    <button (click)="raiseARequest()" class="btn btn-outline-primary px-6 py-2 w-100">Raise a Request</button>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>


                <ng-template #content let-modal>
                    <div class="modal-body">
                        <div class="px-5">
                            <div class="text-center text-primary-dark mb-6 py-4">
                                <h4 class="mb-2">Your request has been send successfully. Our team will get back to you in 2 3 working days</h4>
                                <p class="text-muted">Thanks for co-operating with us </p>
                            </div>
                            <div class="d-flex justify-content-center align-items-center mt-n6">
                                <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1677050781144woman%20in%20online%20meeting%20with%20graphic%20tablet.png" alt="Thank you" class="img img-fluid">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer px-4">
                        <a class="btn btn-primary w-100 text-light" (click)="modal.close('Close click'); logout()">Thank
                            you!</a>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </div>

    <div class="d-lg-none d-block overflow-hidden">
        <div class="fixed-header w-100 mb-9">
            <apnst-common-header [configHeader]="configVendorListHeader" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
        </div>
        <ng-container *ngIf="vendors?.length > 0; else noCriteria">
            <div class="text-primary-dark mt-6">
                <div class="height-vendorList">
                    <ng-container *ngIf="vendors?.length > 0;">
                        <div class="vendorDetails bg-light row overflow-hide">
                            <div class="container mb-2">
                                <div class="d-flex justify-content-center align-items-center flex-column loanAmountBg py-2">
                                    <p><img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715769154002Icon%20%281%29.png" alt=""> Loan without property</p>
                                    <h3 class="text-dark mt-n3 mb-0">{{loanService?.loanDetails?.loanAmountCurrency}} &nbsp; {{prepareViewLoanAmount(loanService?.loanDetails?.loanAmount)}}</h3>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h6 class="text-primary-dark fw-bold mt-2" *ngIf="selectedVendors?.length===0">👆 Select the bank</h6>
                                <h6 class="text-dark fw-bold mt-2" *ngIf="selectedVendors?.length>0"><span class="text-primary-dark me-1">{{selectedVendors?.length}} of
                                        {{vendors?.length}}</span>Banks Selected</h6>
                                <button (click)="openModalSortBy()" class="btn btn-outline-gray text-dark rounded-2 mt-2 px-2 py-1">Sort By</button>
                            </div>
                            <ng-container *ngFor="let vendor of vendors;index as i">
                                <div class="mb-5" (click)="addRemoveVendor(vendor,vendor?.id)">
                                    <div class="custom-card-border bg-white px-3 position-relative" [ngClass]="{' border border-primary':isSelected[vendor?.id]}">
                                        <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715766968416Listed.png" *ngIf="isSelected[vendor?.id]" class="img img-fluid position-absolute selected" alt="selected">
                                        <div class="uniListedText w-60 text-center" *ngIf="loanService?.studentDetails?.universityVendors?.includes(vendor?.vendorNameCaseChanged)">
                                            <p class="text-white p-2 mb-0"><i class="bi bi-check2 me-2"></i>Better Approval Chance</p>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="">
                                                <ng-container *ngIf="vendor?.company?.logo && !vendor?.company?.logo?.includes('public'); else publicLogo">
                                                    <div class="">
                                                        <fa-async-image class="d-block" [src]="vendor?.company?.logo" styleClass="custom-logo-size"></fa-async-image>
                                                    </div>
                                                </ng-container>
                                                <ng-template #publicLogo>
                                                    <div class="">
                                                        <img class="custom-logo-size" [src]="vendor?.company?.logo" [alt]="vendor?.company?.name">
                                                    </div>
                                                </ng-template>
                                            </div>

                                            <div class="mt-3">
                                                <div class="d-flex justify-content-between align-items-center mb-0">
                                                    <img class="img img-fluid mb-1" width="25" src="../../../../assets/logo/rateofinterest.svg" alt="interestLogo">
                                                    <p class="text-gray mb-0">Rate of Interest</p>
                                                </div>
                                                <div class="mt-n2">
                                                    <p class="text-primary-dark fw-bold text-end fs-3" *ngIf="loanService?.loanDetails?.loanType==='Secured Loan(with Property)'">
                                                        {{vendor?.company?.vendorDetails?.collateral?.rateOfInterest}}
                                                    </p>
                                                    <p class="text-primary-dark fw-bold text-end fs-3" *ngIf="loanService?.loanDetails?.loanType==='Unsecured Loan(without Property)'||loanService?.loanDetails?.loanType==='International Loan(Non Collateral-Cosigner)'">
                                                        {{vendor?.company?.vendorDetails?.nonCollateral?.rateOfInterest}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <hr class="text-gray mt-n2">

                                        <div class="d-flex justify-content-between align-items-center mt-n3">
                                            <div class="d-flex justify-content-start align-items-center">
                                                <img class="img img-fluid me-2" width="22" src="../../../../assets/logo/processing-fee.svg" alt="processFeeLogo">
                                                <p class="text-gray mt-3">Processing Fee</p>
                                            </div>
                                            <p class="test-primary-dark fw-bold mt-3">
                                                {{vendor?.company?.vendorDetails?.processingFee}}</p>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center mt-n4">
                                            <div class="d-flex justify-content-start align-items-center mb-0">
                                                <img class="img img-fluid me-2" width="22" src="../../../../assets/logo/approval.svg" alt="processFeeLogo">
                                                <p class="text-gray mt-3">Approval Time</p>
                                            </div>
                                            <p class="test-primary-dark fw-bold mt-3">
                                                {{vendor?.company?.vendorDetails?.tat}}</p>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center mt-n4">
                                            <div class="d-flex justify-content-start align-items-center mb-0">
                                                <img class="img img-fluid me-2" width="22" src="../../../../assets/logo/tenure.svg" alt="processFeeLogo">
                                                <p class="text-gray mt-3">Loan Tenure</p>
                                            </div>
                                            <p class="test-primary-dark fw-bold mt-3">
                                                {{vendor?.company?.vendorDetails?.tenure}}</p>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center mt-n4">
                                            <div class="d-flex justify-content-start align-items-center mb-0">
                                                <img class="img img-fluid me-2" width="22" src="../../../../assets/logo/repayment.svg" alt="processFeeLogo">
                                                <p class="text-gray mt-3">Repayment Mode</p>
                                            </div>
                                            <p class="test-primary-dark fw-bold mt-3">
                                                {{loanService?.studentDetails?.targetDegree==='Bachelors' ? vendor?.company?.vendorDetails?.repaymentOptions?.bachelors:vendor?.company?.vendorDetails?.repaymentOptions?.masters}}
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <div class="fixed-footer w-100">
            <div class="d-flex justify-content-center align-items-center flex-column mt-3" *ngIf="vendors?.length > 0">
                <button class="btn rounded-custom w-100" (click)="sendApplication()" [ngClass]="{'btn-primary':selectedVendors?.length>0,'btn-gray text-white disabled':selectedVendors?.length===0}">Send
                    Application</button>
                <p (click)="openTermsModal()" class="text-gray text-underline">Terms & Condition</p>
            </div>
        </div>

    </div>
</ng-template>


<ng-template #openErrorPopup let-modal>
    <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center flex-column">
            <img class="mb-4" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1699001972962Frame%201000001985.png" alt="errorTriangle">
            <h3 class="text-center mb-4">Please fill out all the required fields or check errors in form</h3>
            <button (click)="goBack()" class="btn btn-primary-goback text-light px-6 rounded-1 fw-bold">Go Back</button>
        </div>
    </div>
</ng-template>

<ng-template #openSortByModal>
    <div class="modal-body sortModal">
        <p class="text-gray">Sort By</p>
        <hr>
        <div class="d-flex justify-content-between align-items-lg-center align-items-start flex-column">
            <button (click)="sortByHandler('rateOfInterest')" class="btn btn-outline-none fw-bold px-3">Rate of
                Interest <img src="../../../../assets/logo/tick.svg" alt="tick" *ngIf="sortParam==='rateOfInterest'"
                    class="img img-fluid" /></button>
            <button (click)="sortByHandler('loanTenure')" class="btn btn-outline-none fw-bold px-3">Loan Tenure <img
                    src="../../../../assets/logo/tick.svg" alt="tick" *ngIf="sortParam==='loanTenure'"
                    class="img img-fluid" /></button>
        </div>
    </div>
</ng-template>

<ng-template #openTermsAndConditionModal let-modal>
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body sortModal">
        <div class="d-flex justify-content-between align-items-center flex-column">
            <p class="text-dark">Terms & Conditions </p>
            <p class="text-gray">These offers are listed only based on eligibility criteria met with academic and financial factors. The final offer may vary based on the document verification. The offers doesn’t include the credit risk assessments and bureau checks</p>
        </div>
    </div>
</ng-template>

<ng-template #openCongratulationPopup>
    <div class="p-3">
        <div class="d-flex justify-content-between align-items-center flex-column">
            <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1699869058836Done%20Icon%20Green%201.png" alt="">
            <h1 class="fst-italic">Congratulations</h1>
            <p class="fs-5 text-center">Your loan application is in progress and sent to the banks.</p>
            <button (click)="checkStatus()" class="btn btn-primary-dark-custom px-7 text-light">Check Status</button>
        </div>
    </div>
</ng-template>